// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aN","header":"aO","copy":"aP","formWrapper":"aQ","formLabel":"aR","dismissModal":"aS","buttonRow":"aT","buttonWrapper":"aU","button":"aV"};